/**
 * Vista: Impresión de Recepción Visual
 * Template HTML optimizado para impresión
 */

import recepcionService from '../services/recepcion.service.js';

export default {
  async render() {
    return `
      <div class="loading-container" style="text-align: center; padding: 3rem;">
        <div class="spinner"></div>
        <p>Cargando formato para impresión...</p>
      </div>
    `;
  },

  async afterRender() {
    const path = window.location.pathname;
    const id = path.split('/')[3]; // /almacen/recepciones/:id/print
    
    try {
      const recepcion = await recepcionService.obtenerPorId(id);
      this.renderPrint(recepcion);
      
      // Auto-abrir diálogo de impresión después de cargar
      setTimeout(() => {
        window.print();
      }, 500);
    } catch (error) {
      console.error('Error:', error);
      document.getElementById('content').innerHTML = `
        <div style="padding: 2rem; text-align: center;">
          <h2>❌ Error al cargar recepción</h2>
          <p>No se pudo cargar la información para imprimir.</p>
          <button onclick="window.close()" class="btn btn-secondary">Cerrar</button>
        </div>
      `;
    }
  },

  renderPrint(r) {
    const html = `
      <div class="print-container">
        <!-- Header con logos -->
        <div class="print-header">
          <div class="print-logo-left">
            <img src="/img/Logo _LOVOL.png" alt="LOVOL" onerror="this.style.display='none'" />
          </div>
          <div class="print-logo-right">
            <img src="/img/Logo_AGRO.png" alt="AGROMX" onerror="this.style.display='none'" />
          </div>
        </div>

        <!-- Título -->
        <h1 class="print-title">RECEPCIÓN VISUAL DE TRACTOR</h1>

        <!-- Datos principales -->
        <div class="print-info-row">
          <div class="print-field">
            <span class="print-label">NUM. SERIE:</span>
            <span class="print-value">${r.num_serie}</span>
          </div>
        </div>

        <div class="print-info-row">
          <div class="print-field" style="flex: 2;">
            <span class="print-label">MODELO:</span>
            <span class="print-value">${r.modelo}</span>
          </div>
          <div class="print-field" style="flex: 1;">
            <span class="print-label">FECHA:</span>
            <span class="print-value">${new Date(r.fecha_recepcion).toLocaleDateString('es-MX')}</span>
          </div>
        </div>

        <!-- Sección Recepción (AMX-AL-FR-02_R4) -->
        <div class="print-section">
          <div class="print-section-title">RECEPCIÓN</div>
          <div class="print-checklist">
            <div class="print-checklist-column">
              <div class="print-check-item">
                <span>DOCUMENTACIÓN</span>
                <span class="print-checkbox${r.checklist?.documentacion ? ' checked' : ''}"></span>
              </div>
              <div class="print-check-item">
                <span>EMBLEMA</span>
                <span class="print-checkbox${r.checklist?.emblema ? ' checked' : ''}"></span>
              </div>
              <div class="print-check-item">
                <span>SALPICADERAS</span>
                <span class="print-checkbox${r.checklist?.salpicaderas ? ' checked' : ''}"></span>
              </div>
              <div class="print-check-item">
                <span>LLANTAS TRASERAS</span>
                <span class="print-checkbox${r.checklist?.llantas_traseras ? ' checked' : ''}"></span>
              </div>
              <div class="print-check-item">
                <span>LLANTAS DELANTERAS</span>
                <span class="print-checkbox${r.checklist?.llantas_delanteras ? ' checked' : ''}"></span>
              </div>
              <div class="print-check-item">
                <span>CAJA DE HERRAMIENTAS</span>
                <span class="print-checkbox${r.checklist?.caja_herramientas ? ' checked' : ''}"></span>
              </div>
              <div class="print-check-item">
                <span>CAJA DE TORNILLERÍA</span>
                <span class="print-checkbox${r.checklist?.caja_tornilleria ? ' checked' : ''}"></span>
              </div>
              <div class="print-check-item">
                <span>BASTIDOR CON BATERÍA</span>
                <span class="print-checkbox${r.checklist?.bastidor_bateria ? ' checked' : ''}"></span>
              </div>
              <div class="print-check-item">
                <span>EJE DELANTERO</span>
                <span class="print-checkbox${r.checklist?.eje_delantero ? ' checked' : ''}"></span>
              </div>
              <div class="print-check-item">
                <span>CUBIERTA DE PTO</span>
                <span class="print-checkbox${r.checklist?.cubierta_pto ? ' checked' : ''}"></span>
              </div>
            </div>

            <div class="print-checklist-column">
              <div class="print-check-item">
                <span>TREN MOTRIZ</span>
                <span class="print-checkbox${r.checklist?.tren_motriz ? ' checked' : ''}"></span>
              </div>
              <div class="print-check-item">
                <span>ESTABILIZADORES</span>
                <span class="print-checkbox${r.checklist?.estabilizadores ? ' checked' : ''}"></span>
              </div>
              <div class="print-check-item">
                <span>MOFLE O ESCAPE</span>
                <span class="print-checkbox${r.checklist?.mofle_escape ? ' checked' : ''}"></span>
              </div>
              <div class="print-check-item">
                <span>BARRA DE TIRO</span>
                <span class="print-checkbox${r.checklist?.barra_tiro ? ' checked' : ''}"></span>
              </div>
              <div class="print-check-item">
                <span>BRAZOS DE LEVANTE</span>
                <span class="print-checkbox${r.checklist?.brazos_levante ? ' checked' : ''}"></span>
              </div>
              <div class="print-check-item">
                <span>CONTRAPESOS TRASEROS</span>
                <span class="print-checkbox${r.checklist?.contrapesos_traseros ? ' checked' : ''}"></span>
              </div>
              <div class="print-check-item">
                <span>CONTRAPESOS DELANTEROS</span>
                <span class="print-checkbox${r.checklist?.contrapesos_delanteros ? ' checked' : ''}"></span>
              </div>
              <div class="print-check-item">
                <span>ROPS/ TOLDO</span>
                <span class="print-checkbox${r.checklist?.rops_toldo ? ' checked' : ''}"></span>
              </div>
              <div class="print-check-item">
                <span>CABINA</span>
                <span class="print-checkbox${r.checklist?.cabina ? ' checked' : ''}"></span>
              </div>
            </div>
          </div>
        </div>

        <!-- Sección Observaciones -->
        <div class="print-section">
          <div class="print-section-title">OBSERVACIONES</div>
          <div class="print-observations">
            <div class="print-obs-line">${r.observaciones || ''}</div>
            <div class="print-obs-line"></div>
            <div class="print-obs-line"></div>
            <div class="print-obs-line"></div>
            <div class="print-obs-line"></div>
            <div class="print-obs-line"></div>
            <div class="print-obs-line"></div>
            <div class="print-obs-line"></div>
          </div>
        </div>

        <!-- Firmas -->
        <div class="print-signatures">
          <div class="print-signature-box">
            ${r.responsable_almacen_firma_url ? `
              <img src="${r.responsable_almacen_firma_url}" alt="Firma" class="print-signature-img" />
            ` : ''}
            <div class="print-signature-line"></div>
            <div class="print-signature-label">ELABORÓ</div>
          </div>
          <div class="print-signature-box">
            ${r.recibio_firma_url ? `
              <img src="${r.recibio_firma_url}" alt="Firma" class="print-signature-img" />
            ` : ''}
            <div class="print-signature-line"></div>
            <div class="print-signature-label">JEFE DE ALMACÉN</div>
            <div class="print-signature-vobo">Vo.Bo.</div>
          </div>
        </div>

        <!-- Franja decorativa -->
        <div class="print-stripe">
          <div class="print-stripe-gray"></div>
          <div class="print-stripe-teal"></div>
        </div>

        <!-- Footer con código del formato -->
        <div class="print-footer">
          <div class="print-footer-cell"><strong>CODIGO</strong><br/>AMX-AL-FR-02_R4</div>
          <div class="print-footer-cell" style="flex: 0.5;"><strong>REVISIÓN</strong><br/>4</div>
          <div class="print-footer-cell" style="flex: 1.5;"><strong>NORMA</strong><br/>NMX-CC-9001-IMNC-2015</div>
          <div class="print-footer-cell"><strong>FECHA PUBLICACIÓN</strong><br/>Junio 2024</div>
          <div class="print-footer-cell"><strong>SUSTITUYE</strong><br/>AMX-AL-FR-02_R3</div>
          <div class="print-footer-cell"><strong>VIGENCIA</strong><br/>Junio 2024 al 2026</div>
          <div class="print-footer-cell" style="display: flex; align-items: center; justify-content: center;">Página 1 de 1</div>
        </div>
      </div>

      <style>
        /* Estilos generales para pantalla */
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }

        body {
          font-family: Arial, sans-serif;
          background: #f5f5f5;
          padding: 20px;
        }

        .print-container {
          max-width: 210mm;
          margin: 0 auto;
          background: white;
          padding: 15mm;
          box-shadow: 0 0 10px rgba(0,0,0,0.1);
        }

        /* Header */
        .print-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 5mm;
        }

        .print-logo-left img,
        .print-logo-right img {
          height: 12mm;
        }

        .print-title {
          text-align: center;
          font-size: 16pt;
          font-weight: bold;
          margin-bottom: 5mm;
          text-transform: uppercase;
        }

        /* Campos de información */
        .print-info-row {
          display: flex;
          gap: 5mm;
          margin-bottom: 3mm;
        }

        .print-field {
          display: flex;
          flex: 1;
          align-items: baseline;
        }

        .print-label {
          font-weight: bold;
          margin-right: 1mm;
          white-space: nowrap;
        }

        .print-value {
          flex: 1;
          text-transform: uppercase;
          border-bottom: 1px solid #000;
          padding-bottom: 1mm;
        }

        /* Secciones */
        .print-section {
          margin: 3mm 0 10mm 0;
        }

        .print-section-title {
          background: #1E4D78;
          color: white;
          text-align: center;
          padding: 1.5mm;
          font-weight: bold;
          font-size: 10pt;
          margin-bottom: 0;
        }

        /* Checklist */
        .print-checklist {
          display: flex;
          gap: 3mm;
          padding-top: 3mm;
        }

        .print-checklist-column {
          flex: 1;
        }

        .print-check-item {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 1.5mm;
          font-size: 8pt;
          line-height: 1.2;
        }

        .print-checkbox {
          display: inline-block;
          width: 5mm;
          height: 4mm;
          border: 1px solid #000;
          margin-left: 2mm;
          text-align: center;
          font-size: 0;
          flex-shrink: 0;
          position: relative;
        }

        .print-checkbox.checked::after {
          content: '✓';
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          font-size: 8pt;
          line-height: 1;
        }

        .print-check-item span:first-child {
          white-space: nowrap;
        }

        /* Observaciones */
        .print-observations {
          border: 1px solid #000;
          border-top: none;
          padding: 2mm;
          font-size: 8pt;
        }

        .print-obs-line {
          border-bottom: 1px solid #000;
          min-height: 5mm;
          font-size: 8pt;
          line-height: 5mm;
        }

        /* Firmas */
        .print-signatures {
          display: flex;
          justify-content: space-around;
          margin: 6mm 0 3mm 0;
        }

        .print-signature-box {
          width: 40%;
          text-align: center;
        }

        .print-signature-img {
          height: 12mm;
          margin-bottom: 1mm;
        }

        .print-signature-line {
          border-top: 1px solid #000;
          margin: 0 auto 1.5mm auto;
          width: 100%;
        }

        .print-signature-label {
          font-weight: bold;
          font-size: 8pt;
          margin-bottom: 0.5mm;
        }

        .print-signature-name {
          font-size: 7pt;
          color: #666;
        }

        .print-signature-vobo {
          font-size: 7pt;
          font-style: italic;
          margin-top: 0.5mm;
        }

        /* Franja decorativa */
        .print-stripe {
          margin: 4mm 0 2mm 0;
        }

        .print-stripe-gray {
          height: 3mm;
          background: #808080;
        }

        .print-stripe-teal {
          height: 5mm;
          background: #00796B;
        }

        /* Footer */
        .print-footer {
          display: flex;
          border: 1px solid #000;
          font-size: 6pt;
          margin-top: 3mm;
        }

        .print-footer-cell {
          flex: 1;
          border-right: 1px solid #000;
          padding: 1.5mm;
          text-align: center;
          line-height: 1.2;
        }

        .print-footer-cell:last-child {
          border-right: none;
        }

        /* Estilos para impresión */
        @media print {
          /* Resetear body */
          body {
            background: white !important;
            padding: 0 !important;
            margin: 0 !important;
          }

          /* Ocultar elementos de navegación específicos */
          .navbar,
          nav.navbar,
          .sidebar,
          aside.sidebar,
          #navbarMenu,
          #navbarUser,
          #loading,
          #toast-container,
          #modal-container,
          .no-print,
          button:not(.print-keep),
          .btn:not(.print-keep) {
            display: none !important;
          }

          /* Ajustar layout principal */
          .main-layout {
            display: block !important;
            margin: 0 !important;
            padding: 0 !important;
          }

          /* Mostrar solo el contenido */
          #app {
            display: block !important;
          }

          #content,
          .content {
            display: block !important;
            margin: 0 !important;
            padding: 0 !important;
            max-width: 100% !important;
          }

          .print-container {
            max-width: 100% !important;
            width: 100% !important;
            padding: 5mm !important;
            margin: 0 auto !important;
            box-shadow: none !important;
            page-break-inside: avoid !important;
            background: white !important;
          }

          @page {
            size: letter;
            margin: 5mm;
          }

          /* Asegurar que las imágenes y firmas se impriman bien */
          .print-signature-img,
          .print-logo-left img,
          .print-logo-right img {
            max-width: 100% !important;
            print-color-adjust: exact !important;
            -webkit-print-color-adjust: exact !important;
          }

          /* Asegurar colores de fondo en impresión */
          .print-section-title,
          .print-stripe-gray,
          .print-stripe-teal {
            print-color-adjust: exact !important;
            -webkit-print-color-adjust: exact !important;
          }

          /* Asegurar que todos los elementos de print-container sean visibles */
          .print-container * {
            visibility: visible !important;
          }

          .print-footer {
            display: flex !important;
          }

          .print-footer-cell {
            display: table-cell !important;
          }
        }
      </style>
    `;

    document.getElementById('content').innerHTML = html;
  }
};
